import { AppState, AppDispatch } from '../../types';
import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useRequestState } from '../../utils/hooks';
import { SettingsRequestActions } from './actions';

export const useFetchSettings = () => {
  const dispatch = useDispatch<AppDispatch>();
  const requestStateStatus = useRequestState((state: AppState) => state.settings.settings);

  const fetchSettings = useCallback(() => {
    dispatch(SettingsRequestActions.getSettings()).catch(() =>
      console.error('Failed to get Settings'),
    );
  }, [dispatch]);

  useEffect(() => fetchSettings(), [fetchSettings]);

  return {
    ...requestStateStatus,
    fetchSettings,
  };
};
